export default "__VITE_ASSET__Bm3Yyy4k__"